// extracted by mini-css-extract-plugin
export var button = "_ef-0";
export var donut = "_ef-1";
export var donutFill = "_ef-3";
export var donutTrack = "_ef-2";